import {
  PayMonthStatusEnum,
  PayrollReportStatusEnum,
  PayrollStartPageViewModel,
} from '@fora-monorepo/employer-my-pages-common/types';

import { mockPayrollReportHeadsData } from './mockPayrollReportHeadsData';

const mockPayrollStartPageDefault: PayrollStartPageViewModel = {
  isAnyReportProcessing: true,
  payMonthOverviews: [
    {
      payMonth: '202212',
      periodFromDate: '2022-12-01',
      periodToDate: '2023-01-31',
      payMonthStatus: PayMonthStatusEnum.ReportingApproved,
      isPeriodOpen: false,
      payrollReportHeads: mockPayrollReportHeadsData.filter(report =>
        report.payMonths.some(pm => pm.payMonth === '202212')
      ),
    },
    {
      payMonth: '202301',
      periodFromDate: '2023-01-01',
      periodToDate: '2023-02-28',
      payMonthStatus: PayMonthStatusEnum.ReportingApproved,
      isPeriodOpen: false,
      payrollReportHeads: mockPayrollReportHeadsData.filter(report =>
        report.payMonths.some(pm => pm.payMonth === '202301')
      ),
    },
    {
      payMonth: '202302',
      periodFromDate: '2023-02-01',
      periodToDate: '2023-03-31',
      payMonthStatus: PayMonthStatusEnum.ReportingApproved,
      isPeriodOpen: false,
      payrollReportHeads: mockPayrollReportHeadsData.filter(report =>
        report.payMonths.some(pm => pm.payMonth === '202302')
      ),
    },
    {
      payMonth: '202303',
      periodFromDate: '2023-03-01',
      periodToDate: '2023-04-30',
      payMonthStatus: PayMonthStatusEnum.ReportingDelayed,
      isPeriodOpen: false,
      payrollReportHeads: mockPayrollReportHeadsData.filter(report =>
        report.payMonths.some(pm => pm.payMonth === '202303')
      ),
    },
    {
      payMonth: '202304',
      periodFromDate: '2023-04-01',
      periodToDate: '2023-05-31',
      payMonthStatus: PayMonthStatusEnum.ReportingApproved,
      isPeriodOpen: false,
      payrollReportHeads: mockPayrollReportHeadsData.filter(report =>
        report.payMonths.some(pm => pm.payMonth === '202304')
      ),
    },
    {
      payMonth: '202305',
      periodFromDate: '2023-05-01',
      periodToDate: '2023-06-30',
      payMonthStatus: PayMonthStatusEnum.ReportingNotDone,
      isPeriodOpen: false,
      payrollReportHeads: mockPayrollReportHeadsData.filter(report =>
        report.payMonths.some(pm => pm.payMonth === '202305')
      ),
    },
    {
      payMonth: '202306',
      periodFromDate: '2023-06-01',
      periodToDate: '2023-07-31',
      payMonthStatus: PayMonthStatusEnum.ReportingApproved,
      isPeriodOpen: true,
      payrollReportHeads: mockPayrollReportHeadsData.filter(report =>
        report.payMonths.some(pm => pm.payMonth === '202306')
      ),
    },
    {
      payMonth: '202307',
      periodFromDate: '2023-07-01',
      periodToDate: '2023-08-31',
      payMonthStatus: PayMonthStatusEnum.ReportingNotDone,
      isPeriodOpen: true,
      payrollReportHeads: mockPayrollReportHeadsData.filter(report =>
        report.payMonths.some(pm => pm.payMonth === '202307')
      ),
    },
  ],
};

const mockReportProcessing: PayrollStartPageViewModel = {
  isAnyReportProcessing: false,
  payMonthOverviews: [
    {
      payMonth: '202307',
      periodFromDate: '2023-07-01',
      periodToDate: '2023-08-31',
      payMonthStatus: PayMonthStatusEnum.ReportProcessing,
      isPeriodOpen: false,
      payrollReportHeads: [
        {
          adminReporterFullName: 'Kalle Anka',
          createdDate: '2023-08-01',
          hasEmploymentData: true,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          payMonths: [
            {
              payMonth: '202307',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          payrollReportId: '123',
          successfullyProcessedDate: null,
          source: 'Visma',
          status: PayrollReportStatusEnum.PROCESSING,
        },
      ],
    },
  ],
};

const mockReporthasDeviations: PayrollStartPageViewModel = {
  isAnyReportProcessing: false,
  payMonthOverviews: [
    {
      payMonth: '202307',
      periodFromDate: '2023-07-01',
      periodToDate: '2023-08-31',
      payMonthStatus: PayMonthStatusEnum.ReportWithDeviations,
      isPeriodOpen: false,
      payrollReportHeads: [
        {
          adminReporterFullName: 'Kalle Anka',
          createdDate: '2023-08-01',
          hasEmploymentData: true,
          hasEmploymentDeviations: true,
          hasEmploymentInformation: false,
          payMonths: [
            {
              payMonth: '202307',
              hasDeviations: true,
              hasInformation: false,
            },
          ],
          payrollReportId: '123',
          successfullyProcessedDate: '2023-08-02',
          source: 'Visma',
          status: PayrollReportStatusEnum.PROCESSING,
        },
      ],
    },
  ],
};

export const mockPayrollStartPage = {
  default: mockPayrollStartPageDefault,
  oneReportProcessing: mockReportProcessing,
  oneReportWithDeviations: mockReporthasDeviations,
};
